<template>
  <div class="school-content">
    <div class="title">
      <img src="../assets/image/x_2_left.png" />
      <span>合作案例</span>
      <img src="../assets/image/x_2_right.png" />
    </div>
    <el-carousel :interval="10000" arrow="always">
      <el-carousel-item>
        <div class="content">
          <el-card shadow="always" v-for="item in filterArr1" :key='item'>
            {{item}}
          </el-card>
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <div class="content">
          <el-card shadow="always" v-for="item in filterArr2" :key='item'>
            {{item}}
          </el-card>
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <div class="content">
          <el-card shadow="always" v-for="item in filterArr3" :key='item'>
            {{item}}
          </el-card>
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <div class="content">
          <el-card shadow="always" v-for="item in filterArr4" :key='item'>
            {{item}}
          </el-card>
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <div class="content">
          <el-card shadow="always" v-for="item in filterArr5" :key='item'>
            {{item}}
          </el-card>
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <div class="content">
          <el-card shadow="always" v-for="item in filterArr6" :key='item'>
            {{item}}
          </el-card>
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <div class="content">
          <el-card shadow="always" v-for="item in filterArr7" :key='item'>
            {{item}}
          </el-card>
          <div class="buttonn">
            <span @click="clickDrawf">院校申请试用</span>
          </div>
        </div>
      </el-carousel-item>

    </el-carousel>

    <!-- <el-pagination background :page-size='pagesize' :current-page="page" @current-change="filterr" layout="prev, pager, next" :total="39" style="margin-bottom:64px;margin-top:24px;">
    </el-pagination> -->
  </div>
</template>

<script>
export default {
  name: 'school',
  data() {
    return {
      page: 1,
      pagesize: 16,
      // schools: [
      //   ,
      //   ,
      //   ,
      // ],
      filterArr1: [
        '宁夏回族自治区教育厅',
        '福建省三明市教育局',
        '陕西铁路工程职业技术学院',
        '南京信息职业技术学院',

        '常州信息职业技术学院',
        '湖南铁道职业技术学院',
        '河南职业技术学院',
        '包头职业技术学院',

        '北京市商业学校',
        '长沙财经学校',
        '浙江科技工程学校',
        '河南省幼儿师范学校',

        '杭州技师学院',
        '北京市工业技师学院',
        '中山技师学院',
        '山东技师学院',
        '潍坊职业学院',
        '天津渤海职业技术学院',
        '东莞职业技术学院',
        '重庆财经职业学院',
      ],
      filterArr2: [
        '安徽工商职业学院',
        '阜阳职业技术学院',
        '南京旅游职业学院',
        '山东商务职业学院',

        '扬州工业职业技术学院',
        '苏州农业职业技术学院',
        '北京青年政治学院',
        '北京政法职业学院',

        '杭州市中策职业学校',
        '郑州市科技工业学校',
        '广东省财经职业技术学校',
        '柳州市第一职业技术学校',

        '嘉兴技师学院',
        '山东工业技师学院',
        '杭州萧山技师学院',
        '四川理工技师学院',
        '江苏医药职业学院',
        '四川中医药高等专科学校',
        '江西卫生职业学院',
        '惠州卫生职业技术学院',
      ],
      filterArr3: [
        '苏州旅游财经高等专科学校',
        '福建省邮电学校',
        '南昌汽车机电学校',
        '徐州财经高等职业技术学校',

        '江西省商务技师学院',
        '中铁十三局技师学院',
        '福州第二技师学院',
        '广东省高新技术高级技工学校',
        '河套学院',
        '运城职业技术大学',
        '广西民族师范学院',
        '湖南医学院',

        '苏州幼儿师范高等专科学校',
        '运城幼儿师范高等专科学校',
        '宁夏幼儿师范高等专科学校',
        '阜阳幼儿高等师范专科学校',

        '温州华侨中等专业学校',
        '桐庐县职业技术学校',
        '沈阳市信息工程学校',
        '天津市东丽区职业教育中心学校',
      ],
      filterArr4: [
        '江西交通职业技术学院',
        '江西建设职业技术学院',
        '湖南生物机电职业技术学院',
        '娄底职业技术学院',
        '四川化工职业技术学院',
        '重庆工贸职业技术学院',
        '重庆航天职业技术学院',
        '成都工贸职业技术学院',

        '郑州市信息技术学校',
        '郑州市商贸管理学校',
        '开封市卫生学校',
        '福建经济学校',

        '惠州城市职业技术学院',
        '惠州工程职业学院',
        '茂名职业技术学院',
        '湖南交通职业技术学院',
        
        '浙江建设技师学院',
        '桐乡技师学院',
        '江西技师学院',
        '东莞联合高级技工学校',
      ],
      filterArr5: [
        '长春金融高等专科学校',
        '长春医学高等专科学校',
        '内蒙古电子信息职业技术学院',
        '包头铁道职业技术学院',

        '常州工业职业技术学院',
        '江苏航空职业技术学院',
        '安庆职业技术学院',
        '安阳职业技术学院',

        '漳州城市职业技术学院',
        '厦门海洋职业技术学院',
        '厦门城市职业学院',
        '三明医学科技职业技术学院',

        '内蒙古大学交通职业技术学院',
        '内蒙古机电职业技术学院',
        '内蒙古科技大学',
        '兰州财经大学龙桥学院',

        '伊宁市职业技术教育中心',
        '温州华侨中等专业学校',
        '余姚市第四职业技术学校',
        '庆阳市机电工程学校',
      ],
      filterArr6: [
        '福州建筑工程职业中专学校',
        '福建省长汀职业中专学校',
        '厦门市同安职业技术学校',
        '嘉善县中等专业学校',

        '苏州技师学院',
        '诸暨技师学院',
        '慈溪技师学院',
        '河南医药技师学院',

        '延安职业技术学院',
        '神木职业技术学院',
        '甘肃有色冶金职业技术学院',
        '陇南师范高等专科学校',

        '山东圣翰财贸职业学院',
        '广州华夏职业学院',
        '惠州经济职业技术学院',
        '信阳涉外职业技术学院',

        '郑州铁路职业技术学院',
        '湖南科技职业学院',
        '陕西艺术职业学院',
        '重庆水利电力职业技术学院',
      ],
      filterArr7: [
        '黔南民族职业技术学院',
        '贵州工程职业学院',
        '郑州城市职业学院',
        '荆州职业技术学院',
        '东莞市机电工程学校',
        '东莞市汽车技术学校',
        '东莞市电子科技学校',
        '福州建筑工程职业中专学校',
        '江苏省惠山中等专业学校',
        '中山市中等专业学校',
        '中山市第一中等职业技术学校',
        '中山市建斌中等职业技术学校',
        '广西工业职业技术学院',
        '怀化职业技术学院',
        '广西第一工业学校',
        '长沙建筑工程学校',
        '.........全国数百所院校',
      ],
    };
  },
  components: {},
  created() {
    // this.filterr(1);
  },
  mounted() {
    // this.getStudentApply()
    // this.getProvince()
  },
  computed: {
    isToken() {
      return this.$store.state.token;
    },
    userInfo() {
      return this.$store.state.userInfo;
    },
  },
  methods: {
    filterr(val) {
      // this.filterArr=this.schools.splice((this.page-1)*this.pagesize,this.page*this.pagesize)
      this.page = val;
      this.filterArr = this.schools.filter((item, index) => {
        return index + 1 > (this.page - 1) * this.pagesize && index < this.page * this.pagesize;
      });
    },
    handLoginClick() {
      this.$router.push({
        path: '/login',
      });
    },
    handleCommand(com) {
      if (com == 'logOut') {
        this.handleBack();
      }
    },
    clickDrawf() {
      this.$emit('openDrawf');
    },
    handleBack() {
      this.$store.commit('setUserInfo', null);
      this.$store.commit('setToken', null);
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.el-carousel__arrow {
  background-color: rgba(72, 135, 200, 0.8);
}
/deep/.el-card {
  width: 248px;
  text-align: center;
  margin-left: 26px;
  margin-bottom: 22px;
  color: #487fb7;
  font-weight: bold;
  font-size: 14px;
  background-image: linear-gradient(to right, #d9e8f5, #eaeaea);
}
/deep/.el-carousel__container {
  // display: flex;
  // flex-wrap: wrap;
  // justify-content: flex-start;
  // padding: 32px 32px 0;
  height: 500px;
}
/deep/.el-carousel__button {
  background-color: #2f638c;
}
.buttonn {
  margin-left: 188px;
  margin-top: 8px;
  span {
    // border-bottom: 4px solid #6bbfff;
    // padding-bottom: 4px;
    color: #1b70b9;
    display: inline-block;
    background: #fff;
    padding: 12px 36px;
    font-size: 20px;
    font-weight: bold;
    border-radius: 28px;
    letter-spacing: 3px;
    box-shadow: 0 0 5px 1px #adadad;
    background-image: linear-gradient(to right, #bdd5ea, #f1f1f1);
    cursor: pointer;
  }
  span:hover {
    // border-bottom: 4px solid #a7373a;
    // color: #a7373a;
    // box-shadow: 0 0 1px 1px #423c3c;
    background-image: linear-gradient(to right, #e8e8e8, #bdd5ea);
  }
}
.school-content {
  padding: 100px 24px 120px;
  width: 1200px;
  margin: 0 auto;
  color: #444;
  .button {
    padding: 56px 32px;
  }
  .title {
    margin-bottom: 54px;
    span {
      margin: 0 16px;
      font-size: 26px;
    }
    img {
      vertical-align: text-top;
    }
  }
  .content {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    padding: 32px 32px 0;
  }
}
</style>
